import React from 'react';

interface SkeletonProps {
  className?: string;
  variant?: 'text' | 'rect' | 'circle';
  width?: string | number;
  height?: string | number;
  style?: React.CSSProperties;
}

const Skeleton: React.FC<SkeletonProps> = ({
  className = '',
  variant = 'rect',
  width,
  height,
  style,
}) => {
  const baseClass = 'animate-pulse bg-slate-200 dark:bg-slate-700';
  const variantClass = {
    text: 'rounded-md h-4 w-full mb-2',
    rect: 'rounded-md',
    circle: 'rounded-full',
  }[variant];

  return (
    <div
      className={`${baseClass} ${variantClass} ${className}`}
      style={{
        width,
        height,
        ...style,
      }}
    />
  );
};

export default Skeleton;
